<template>
    <div>
        <div class="col-sm-12">
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingDesgin.fontSize') }} </label>
                <div class="col-sm-4">
                    {{ dataForm.style_setting?.font?.name }}
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingDesgin.squareType') }} </label>
                <div class="col-sm-9">
                    {{ renderNameTypeBorder(dataForm.style_setting?.border_radius_type) }}
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingDesgin.PCBackgroundColor') }} </label>
                <div class="col-sm-10">
                    <div>
                        <div v-if="dataForm.style_setting.pc.background_image?.path" style="width: 200px; height: 200px" class="position-relative">
                            <b-img
                                class=""
                                thumbnail
                                fluid
                                :src="dataForm.style_setting.pc.background_image?.path"
                                :alt="dataForm.style_setting.pc.background_image.origin_name"
                                style="width: 100%; height: 100%; object-fit: cover; object-position: center; border-radius: 10px"
                            ></b-img>
                        </div>
                    </div>
                    <div class="form-group row mt-2">
                        <label class="col-sm-1 text-nowrap" style="min-width: 50px">{{ $t('landingPage.backgroundText') }}</label>
                        <div class="col-sm-5">
                            <div class="d-flex" style="gap: 1rem">
                                <InputText
                                    style="min-width: 100px"
                                    :model.sync="dataForm.style_setting.pc.background_color"
                                    :config="{
                                        type: 'color',
                                        classCustom: 'form-control-color',
                                        error: false
                                    }"
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <InputCheckBox
                            :model.sync="dataForm.style_setting.pc.is_repeat"
                            :id="`check-repeat-background-PC`"
                            :value="dataForm.style_setting.pc.is_repeat"
                            :label="`repeat`"
                            disabled
                        />
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingDesgin.SPBackgroundColor') }} </label>
                <div class="col-sm-10">
                    <div>
                        <div v-if="dataForm.style_setting.sp.background_image?.path" style="width: 200px; height: 200px" class="position-relative">
                            <b-img
                                class=""
                                thumbnail
                                fluid
                                :src="dataForm.style_setting.sp.background_image?.path"
                                :alt="dataForm.style_setting.sp.background_image.origin_name"
                                style="width: 100%; height: 100%; object-fit: cover; object-position: center; border-radius: 10px"
                            ></b-img>
                        </div>
                    </div>
                    <div class="form-group row mt-2">
                        <label class="col-sm-1 text-nowrap" style="min-width: 50px">{{ $t('landingPage.backgroundText') }}</label>
                        <div class="col-sm-5">
                            <div class="d-flex" style="gap: 1rem">
                                <InputText
                                    style="min-width: 100px"
                                    :model.sync="dataForm.style_setting.sp.background_color"
                                    :config="{
                                        type: 'color',
                                        classCustom: 'form-control-color',
                                        error: false
                                    }"
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <InputCheckBox
                            :model.sync="dataForm.style_setting.sp.is_repeat"
                            :id="`check-repeat-background-SP`"
                            :value="dataForm.style_setting.sp.is_repeat"
                            :label="`repeat`"
                            disabled
                        />
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-1 text-nowrap" style="min-width: 150px">{{ $t('landingPage.settingDesgin.templateDefault') }} </label>
                <div class="col-sm-1">
                    <div class="mt-2" style="width: 100px; height: 80px">
                        <img
                            class="w-100 h-100"
                            style="object-fit: cover"
                            :src="dataForm.style_setting?.template_default?.image_preview"
                            :alt="dataForm.style_setting?.template_default?.image_preview"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { LIST_FONT_PAGE, SQUARE_TYPE_PAGE } from '../../../constants';
import { InputText, InputCheckBox } from '@/components/Input';

export default {
    name: 'SettingDesginLP',
    components: { InputText, InputCheckBox },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },
    data() {
        return {
            listFontFamily: LIST_FONT_PAGE,
            listSquareType: SQUARE_TYPE_PAGE
        };
    },
    methods: {
        renderNameTypeBorder(type) {
            const item = this.listSquareType.find((item) => item.id === type);
            return item ? item.value : '';
        }
    }
};
</script>

<style lang="scss" scoped></style>
